import { appVersion } from './app-version';
import { AppConfiguration } from './AppConfiguration';
import { supportedLanguages } from './supported-languages';
import { roles } from './roles';

export const environment: AppConfiguration = {
    production: true,
    instana: true,
    serviceWorkerEnabled: false,
    version: appVersion,
    env: 'production',
    app: {
        defaultLanguage: 'de-DE',
        supportedLanguages,
        productCategoryGroupNameMapSalesOrg: ['6200'],
        partnerShopNotRelevantSalesOrgs: ['8000'],
        checkSalesOrgPermission: true,
        roles,
    },
    appInsights: {
        enabled: true,
        connectionString:
            'InstrumentationKey=28f15ec9-6b9f-46ff-9802-e4a9e1cc91dd;IngestionEndpoint=https://northeurope-2.in.applicationinsights.azure.com/;LiveEndpoint=https://northeurope.livediagnostics.monitor.azure.com/;ApplicationId=5cf97019-720a-4fc6-8f22-e030a9912293',
    },
    quest: {
        context: 'quest',
        dropoutGroup: 'Dropout',
        project: 'QuoteAssist',
        modelSelectionVariable: 'Anonymous.ProductGroup',
        preselectionVariable: 'Miscellaneous.PreSelection',
        acePackagePath: 'Internal/master',
    },
    configit: {
        url: 'https://api.viessmann-climatesolutions.com/backend/package-packer/v3',
        languages: ['de_DE'],
        salesAreaName: 'Germany',
        plant: '0500',
        usage: '5',
    },
    offline: {
        enabled: false,
        keyword: 'offline=1',
        baseUrl: 'https://quote-assist.viessmann-climatesolutions.com/assets/offline/',
    },
    http: {
        shopUrl: 'https://shop.viessmann-climatesolutions.com/?shopApiContext=qa-import&offerNumber=',
        foerderProfiUrl:
            'https://energie-gestalter.de/?utm_source=angebots_assistent&utm_medium=referral&utm_campaign=kostenfreie_pruefung',
        baseUrl: 'https://api.viessmann-climatesolutions.com/backend/package-packer/v3/',
        viBooksBaseUrl: 'https://vibooks.viessmann-climatesolutions.com',
        serviceConfiguratorBaseUrl: 'https://service-configurator.viessmann-climatesolutions.com',
        users: 'https://api.viessmann-climatesolutions.com/users/v1/users/me?sections=identity&sections=sales&sections=roles',
        translations:
            'https://api.viessmann-climatesolutions.com/translations/v2/phraseapp-proxy/projects/f904ba58454342e5ede6967b374ef7f9/locales/',
        dswTranslations:
            'https://api.viessmann-climatesolutions.com/translations/v2/phraseapp-proxy/projects/ec38b083a23c58c604a49d7f443dd7f2/locales/',
        statusPage: 'https://api.viessmann-climatesolutions.com/status/v1/apps/rhwny5sryyyt/summary',
        configuration: 'https://api.viessmann-climatesolutions.com/backend/configuration/v1/',
        quotation: 'https://api.viessmann-climatesolutions.com/quotation/v1/',
        viGuidePlanningUrl: 'https://viguide-planning.viessmann-climatesolutions.com/project/',
        faq: {
            '0500': 'https://partnerportal.viessmann-climatesolutions.com/de/de/support/faq/quote-assist.html',
            default: 'https://partnerportal.viessmann-climatesolutions.com',
        },
        companyUrl: 'https://api.viessmann-climatesolutions.com/company/v3/companies/',
        pim: {
            baseUrl: 'https://api.viessmann-climatesolutions.com/backend/pim/v1/',
            strict: true,
        },
        staticResources: 'https://static.viessmann-climatesolutions.com/resources/pim/cpq',
    },
    globalHeader: {
        baseUrl: 'https://api.viessmann-climatesolutions.com',
        accountAppUrl: 'https://account.viessmann-climatesolutions.com',
    },
    saml: {
        appId: 'quote-assist',
        baseUrl: 'https://api.viessmann-climatesolutions.com',
    },
    file: {
        uploadUrl: 'upload',
        downloadUrl: 'download',
    },
    feature: {
        salesorgSwitcher: false,
    },
    requireSalesOrg: true,
};
